// Tips-turen (Iason, okt. 2026): fem korte kort, der forklarer det, hånden ikke viser. Hvert kort lyser
// en del af HUD'en op og mørkner resten. Den kommer én gang, efter spillerens første ledning, kan
// springes over og kan startes igen fra pausearket. Tiden står stille, mens den er fremme.

import { h, setText } from './dom';

export interface Tip {
  /** CSS-vælger for det, kortet peger på. Mangler den, eller er målet skjult, står kortet midt på. */
  at?: string;
  title: string;
  text: string;
}

export const TIPS: Tip[] = [
  {
    at: '.kpi.green',
    title: 'Målet',
    text: 'Få den grønne andel op over stregen, før banen slutter. Vindmøller og sol tæller, kul gør ikke.',
  },
  {
    at: '.kpi.trust',
    title: 'Mørkeure og tillid',
    text: 'En by uden nok strøm fylder et rødt ur. Løber det fuldt, mister du et hjerte. Ingen hjerter, ingen vagt.',
  },
  {
    at: '.kpi.money',
    title: 'Kassen',
    text: 'Strøm, du leverer, giver penge hen over året. Fortryder du inden for 3 s, får du alt igen. River du ned senere, får du kun en fjerdedel tilbage i skrot.',
  },
  {
    at: '#tools',
    title: 'Orange er travlt',
    text: 'En orange ledning er overbelastet. Opgradér den, før den brænder af. Kommer en storm, så forstærk masterne eller send montøren.',
  },
  {
    at: '.icon-btn.ai',
    title: 'Kører du fast?',
    text: 'Lad AI spille et stykke og se, hvordan den gør. Den siger hvert træk, før det sker, og du tager over, når du vil.',
  },
];

export class TipsTour {
  readonly el: HTMLElement;
  private spot = h('div', { class: 'tips-spot', 'aria-hidden': 'true' });
  private title = h('h2', { class: 'tips-title', id: 'tips-title' });
  private text = h('p', { class: 'tips-text' });
  private count = h('span', { class: 'tips-count' });
  private nextBtn: HTMLButtonElement;
  private skipBtn: HTMLButtonElement;
  private i = 0;
  private target: Element | null = null;

  constructor(private done: (skipped: boolean) => void) {
    this.nextBtn = h('button', { type: 'button', class: 'btn primary tips-next', onclick: () => this.next() });
    this.skipBtn = h('button', { type: 'button', class: 'btn ghost tips-skip', onclick: () => this.close(true) }, 'Spring over');
    const card = h('div', { class: 'tips-card' }, this.count, this.title, this.text, h('div', { class: 'tips-actions' }, this.skipBtn, this.nextBtn));
    this.el = h('div', { class: 'tips', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'tips-title', hidden: true }, this.spot, card);
    this.el.addEventListener('keydown', (e) => {
      // Spillets taster (pause, værktøjer, A) venter, til turen er lukket.
      e.stopPropagation();
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close(true);
      }
    });
  }

  get open(): boolean {
    return !this.el.hidden;
  }

  start(): void {
    this.i = 0;
    this.el.hidden = false;
    this.show();
    this.nextBtn.focus({ preventScroll: true });
  }

  /** Følger målet, hvis HUD'en flytter sig (rotation, ny række power-ups). */
  update(): void {
    if (this.open) this.place();
  }

  private show(): void {
    const t = TIPS[this.i]!;
    setText(this.count, `${this.i + 1} af ${TIPS.length}`);
    setText(this.title, t.title);
    setText(this.text, t.text);
    const last = this.i === TIPS.length - 1;
    setText(this.nextBtn, last ? 'Spil videre' : 'Næste');
    this.skipBtn.hidden = last;
    this.target = t.at ? document.querySelector(t.at) : null;
    this.place();
  }

  private place(): void {
    const r = this.target?.getBoundingClientRect();
    const seen = r && r.width > 0 && r.height > 0;
    this.el.classList.toggle('free', !seen);
    if (!seen) return;
    const pad = 6;
    Object.assign(this.spot.style, {
      left: `${r.left - pad}px`,
      top: `${r.top - pad}px`,
      width: `${r.width + pad * 2}px`,
      height: `${r.height + pad * 2}px`,
    });
    // Kortet står på den side af skærmen, der er længst fra målet.
    this.el.classList.toggle('low', r.top + r.height / 2 < innerHeight / 2);
  }

  private next(): void {
    if (this.i >= TIPS.length - 1) return this.close(false);
    this.i++;
    this.show();
  }

  private close(skipped: boolean): void {
    this.el.hidden = true;
    this.target = null;
    this.done(skipped);
  }
}
